/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_himsearch.js                                                                         */
/**********************************************************************************************************************/
/* Controller HimSearch */

/**
 * @class this.Controller.HimSearch
 */
HafasWebapp.prototype.Controller.HimSearch = {
  /**
   * @class this.Controller.HimSearch.index
   *
   * @param data
   */
  localOptionsActive: Hafas.Config.Options.storeOptions, // Flag used to save if the options should be saved locally, false if the options are specified via URL parameters
  localOptionsLoaded: false, // Flag used to save whether the options were loaded once from the storage at webapp / context start
  lastView: null,

  index: function () {
    var me = this;
    var controller = me.Controller.HimSearch;

    controller.edges = {};
    controller.mainContainer = Hafas('#' + me.resultOverviewContainer + ' [data-contid="' + me.appContext + '"]');
    controller.instance.setSortMode('sDate');
    controller.currentView = 'index';

    Hafas.bind(controller.cleanup, this)();

    Hafas.Modules.Loader.loadTemplateFiles(['himsearch.index.html', 'himsearch.result.overview.html', 'himsearch.result.detail.html'], Hafas.bind(function () {
      Hafas.bind(controller.renderIndex, me)();
    }, this));
  },

  createIndexModel: function () {
    var me = this;
    var controller = me.Controller.HimSearch;

    var model = {};

    // datumsfilter verwenden?
    model.useDateFilter = Hafas.Config.HimSearch.useDateFilter || false;

    // sortierung
    model.sortMode = controller.instance.getSortMode();

    // textfilter verwenden?
    if (Hafas.Config.HimSearch.useTextFilter) {
      model.textFilter = {
        inputClass: "",
        id: "HFS_HimSearchTextFilter",
        label: Hafas.Modules.i18n.get('HimSearch.label.t_N_TextSearch'),
        name: "HFS_HimSearchTextFilter",
        extendAttributes: "onchange=\"Hafas.ps.pub('/HimSearch/setTextFilter', [{ value:this.value }]);\"",
        placeholder: Hafas.Modules.i18n.get('HimSearch.label.t_N_TextSearch_Placeholder'),
        value: ""
      };
    }

    // Product / Linefilter (HPRWAPP-1338)
    if (Hafas.Config.HimSearch.useLineFilter) {
      model.lineFilter = {
        inputClass: "",
        id: "HFS_HimSearchProductFilter",
        label: Hafas.Modules.i18n.get('HimSearch.label.t_N_ProductSearch'),
        name: "HFS_HimSearchProductFilter",
        extendAttributes: "onchange=\"Hafas.ps.pub('/HimSearch/setProductFilter', [{ value:this.value }]);\"",
        placeholder: Hafas.Modules.i18n.get('HimSearch.label.t_N_ProductSearch_Placeholder'),
        value: ""
      };
    }

    // produkt- und kategoriefilter -> siehe options_HimSearch.json
    if (Hafas.Config.HimSearch.useQueryOptions) {
      model.customerOptions = this.Controller.HimSearch.options.get();
      model.useOptions = true;
    }

    return model;
  },

  renderIndex: function () {
    var me = this;
    var controller = me.Controller.HimSearch;

    var model = Hafas.bind(controller.createIndexModel, this)();

    if (Hafas.Modules.History) {
      Hafas.Modules.History.addData("HimSearch", "index", {});
    }

    controller.mainContainer.innerHTML = Hafas.Modules.Render.renderTemplate("HimSearch_TplIndex", model);

    // date time picker initialisieren, falls aktiviert
    if (model.useDateFilter === true) {

      controller.instance.setDate(Hafas.Config.serverDate, 'B');
      controller.instance.setTime(Hafas.Config.serverTime, 'B');

      // timedate picker zeitraum beginn
      var sDTPConfig = {
        holder: "HFS_HimSearchDateBDateTimePickerHolder",
        id: "HimSearch_dateB",
        config: {
          useDepArrSwitch: false,
          useNowMode: true
        }
      };

      // timedate picker zeitraum ende
      var eDTPConfig = {
        holder: "HFS_HimSearchDateEDateTimePickerHolder",
        id: "HimSearch_dateE",
        config: {
          useDepArrSwitch: false,
          useNowMode: false
        },
        current: {
          date: controller.instance.getDate('E'),
          time: controller.instance.getTime('E')
        }
      };

      controller.sDateDTP = Hafas.Core.newType('hafasTimeDatePicker', sDTPConfig);
      controller.eDateDTP = Hafas.Core.newType('hafasTimeDatePicker', eDTPConfig);
    }

    Hafas.ps.pub('/app/events/renderDone');

    var resultOverviewContainer = Hafas('#HimSearch_ResultOverview');
    resultOverviewContainer.setAttribute('data-him-view', 'index');
    resultOverviewContainer.removeClassName('lyr_himSearch_collapsedInput');


    Hafas.ps.pub('/GUI/tabNavigationHeading/show'); // Muss hier gesondert gerufen werden, da kein /GUI/form/show gerufen wird

    // Track
    Hafas.ps.pub('/tracking/screen/himsearch-main');
    Hafas.ps.pub('/GUI/results/overview/show', [{}]);
    Hafas.ps.pub('/app/events/resize');
    Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

    Hafas.ps.pub('/HimSearch/renderCategoryDescription');
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);

    if (Hafas.Config.Options.storeOptions && me.Controller.HimSearch.localOptionsLoaded === false) {
      // Use stored options in loading the view once, if options are active and the storeOptions config is set
      Hafas.ps.pub('/options/storage/set');
      me.Controller.HimSearch.localOptionsLoaded = true;
    }

    Hafas.Util.gui.focusTabOrMenuButton();

    // trigger search?
    if (Hafas.Config.HimSearch.searchOnStart) {
      Hafas.ps.pub('/HimSearch/postForm');
    }
  },

  // meldungszeitraum beginn setzen
  setBeginDate: function (date, time, forward, timenow) {
    var me = this;
    var controller = me.Controller.HimSearch;

    controller.instance.setDate(date, 'B');
    controller.instance.setTime(time, 'B');
  },

  // meldungszeitraum ende setzen
  setEndDate: function (date, time, forward, timenow) {
    var me = this;
    var controller = me.Controller.HimSearch;

    controller.instance.setDate(date, 'E');
    controller.instance.setTime(time, 'E');
  },

  selectProduct: function (pCls, boolval, checkbox) {
    var me = this;
    var controller = me.Controller.HimSearch;

    // eine abwahl aller produkte soll es nicht geben, deshalb hier prüfen, ob noch mind. eines aktiv ist
    if (!boolval) {
      var prodCheckboxes = Hafas('#HFS_HimSearchProductOptions_Panel input[type="checkbox"]', true);
      if (prodCheckboxes.length > 0) {
        var checkedCount = Hafas('#HFS_HimSearchProductOptions_Panel input[type="checkbox"]:checked', true).length;
        if (checkedCount === 0 && (typeof checkbox !== 'undefined')) {
          checkbox.checked = true;
          return;
        }
      }
    }

    controller.instance.setProductClass(pCls, boolval);
    controller.options.setProduct(pCls, boolval);

    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
  },

  checkActiveCategories: function (data) {
    // eine abwahl aller kategorien soll es nicht geben, deshalb hier prüfen, ob noch mind. eine aktiv ist
    try {
      if (data.id.indexOf('HFS_himSearch_category') !== -1) {
        if (data.value === false) {
          var checkboxes = Hafas('#HFS_HimSearchFilterCategory_Panel input[type="checkbox"]', true);
          if (checkboxes.length > 0) {
            var checkedCount = Hafas('#HFS_HimSearchFilterCategory_Panel input[type="checkbox"]:checked', true).length;
            if (checkedCount === 0 && (typeof data.elem !== 'undefined')) {
              data.elem.checked = true;
              data.value = true;
              Hafas.ps.pub('/options/set/value', [data]);
            }
          }
        }

        Hafas.ps.pub('/HimSearch/renderCategoryDescription', [true]);
      }
    }
    catch (e) {
    }
  },

  /**
   * @param {boolean} setChanges Whether or not the OptionInputForm should update itself with the recent changes
   */
  renderCategoryDescriptions: function (setChanges) {
    var me = this;
    var controller = me.Controller.HimSearch;
    window.setTimeout(function () {
      if (Hafas.Config.HimSearch.useQueryOptions === true) {
        var changedOptions = controller.options.storeChangedOptions();
        var output = "";
        changedOptions.parameters.forEach(function (currParam) {
          if (currParam.name.indexOf("himSearch_category_") !== -1) {
            if (output !== '') {
              output += ', ';
            }
            output += Hafas.Modules.i18n.get("TP.options.t_N_without") + ' ' + currParam.label;
          }
        });
        if (output === '') {
          output = Hafas.Modules.i18n.get("HimSearch.label.t_N_AllCategories");
        }

        try {
          Hafas('[data-additional-info="selected_category_HimSearch"]').innerHTML = '<div class="lyr_atomOptionInfoText">' + output + '</div>';
        } catch (e) {
        }
      }
      if (setChanges) {
        Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
      }
    }, 10);
  },

  closeOptionGroups: function (params) {
    // product group
    var prodGroupBtn = Hafas('#HFS_HimSearchProductOptions_Tab');
    if (prodGroupBtn && prodGroupBtn.getAttribute('aria-expanded') === "true") {
      Hafas.ps.pub('/options/gui/toggle/group', [{
        trigger: prodGroupBtn,
        target: 'products_group',
        groupId: 'HFS_HimSearchProductOptions'
      }]);
    }

    // category group
    var catGroupBtn = Hafas('#HFS_HimSearchFilterCategory_Tab');
    if (catGroupBtn && catGroupBtn.getAttribute('aria-expanded') === "true") {
      Hafas.ps.pub('/options/gui/toggle/group', [{
        trigger: catGroupBtn,
        target: 'himSearch_filter_category',
        groupId: 'HFS_HimSearchFilterCategory'
      }]);
    }
  },

  hideSortOrder: function (params) {

    var sortModeBtn = Hafas('#HFS_HimSearchToggleSortModeBtn');
    if (sortModeBtn) {
      sortModeBtn.setAttribute('aria-expanded','false')
      var containerId = sortModeBtn.getAttribute('aria-controls');
      Hafas('#' + containerId).hidden = true;
      Hafas.ps.pub('/GUI/common/atomToggleContainer', [{trigger: sortModeBtn, open: false}]);
    }
  },
  // Produktfilter setzen
  setProductFilter: function(obj){
    var me = this;
    var controller = me.Controller.HimSearch;

    controller.instance.setProductFilter(obj.value);
  },

  // textfilter setzen
  setTextFilter: function (obj) {
    var me = this;
    var controller = me.Controller.HimSearch;

    controller.instance.setTextFilter(obj.value);
  },

  setSortMode: function (data) {

    if (data.trigger) {
      this.Controller.HimSearch.instance.setSortMode(data.trigger.value);

      // anzeige des sortierungshinweises
      var sortOrderHint = Hafas('#HFS_HimSearchSortOrderHint');
      if (sortOrderHint) {
        sortOrderHint.innerHTML = Hafas.Modules.Render.renderTemplate("HimSearch_TplCurrentSortMode", {sortMode: data.trigger.value});
      }

      // nur neu rendern, wenn auch ergebnisse vorliegen
      if (this.Controller.HimSearch.instance.getResults().messages.length > 0) {
        this.Controller.HimSearch.reRender();
      }
    }

    // ggf. das flyout mit den filteroptionen schliessen (ausgebaut, weil nicht im einklang mit tastaturbedienung machbar)
    //Hafas.ps.pub('/HimSearch/hideSortOrder');
  },

  reRender: function () {
    var response = this.instance.getResults();

    if (typeof Hafas.Config.showDataModel !== 'undefined' && Hafas.Config.showDataModel) {
      console.log('+++ HimSearch.reRender +++ DEBUG Model +++', response)
    }

    Hafas.Modules.Render.render({
      file: 'himsearch.result.overview.html',
      target: 'HFS_HimSearch_ResultContainer',
      template: 'HimSearch_TplResults',
      model: response
    }, Hafas.bind(function () {
      Hafas.ps.pub('/app/events/resize');
      Hafas.Util.gui.resetScrollTop();
    }, this));

  },

  // suche starten
  postForm: function (data) {
    var me = this;
    var controller = me.Controller.HimSearch;

    try {
      data.ev.preventDefault();
    } catch (e) {
    }

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');

    // ggf. aufgeklappte optionen schliessen
    Hafas.bind(controller.closeOptionGroups, me)();

    // close date time picker if it is open
    controller.sDateDTP.confirm();
    controller.eDateDTP.confirm();

    // show loadingImage and set Button to disabled
    try {
      Hafas.bind(this.Controller.App.triggerLoadingImage, this)(data.form.elements.submitHimSearchForm);
    } catch (e) {
    }

    this.Controller.HimSearch.instance.search({
      callback: Hafas.bind(this.Controller.HimSearch.showResultOverview, this)
    });

    // overview leeren
    var himSearchResultContainer = Hafas('#HFS_HimSearch_ResultContainer');
    if (himSearchResultContainer !== null) {
      himSearchResultContainer.innerHTML = '';
    }
    Hafas.bind(this.Controller.HimSearch.clearMapContent, this)();
    Hafas.bind(this.Controller.HimSearch.removeFlyoutFromMap, this)();
    Hafas.ps.pub('/HimSearch/hideSortOrder');

    // Ladescreen anzeigen
    Hafas.bind(this.Controller.HimSearch.showLoadingView,this)();

    // Track
    Hafas.ps.pub('/tracking/event/himsearch-request', [{type: 'HimSearch'}]);

    Hafas.ps.pub('/app/events/resize');
    return false;
  },
  showLoadingView: function(){
    var me = this;
    var controller = me.Controller.HimSearch;

    var himSearchResultContainer = Hafas('#HFS_HimSearch_ResultContainer');
    var countArr = new Array(8);
    for(var c=0; c < countArr.length;c++){
      countArr[c] = {};
    }

    // Laderoutine
    // Ghostloading Elemente rendern
    himSearchResultContainer.innerHTML = Hafas.Modules.Render.renderTemplate("HimSearch_TplLoadingView",{count: countArr },{suppressAnnouncements: true});

    // InfiniteLoader initialisieren
    var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite", {id: "HFS_LineSearch_OverviewLoader"},{suppressAnnouncements: true});
    Hafas('#HFS_HimSearch_ResultContainer',false).insertAdjacentHTML('afterbegin', loaderHtml);

    Hafas('#HimSearch_ResultOverview').setAttribute('data-him-view', 'results');

    // Add .lyr_himSearch_collapsedInput to show results in new view
    controller.mainContainer.addClassName('lyr_himSearch_collapsedInput');

    // Set current view to "overview"
    controller.currentView = 'overview';

    Hafas.ps.pub('/GUI/tabNavigationHeading/hide');

    // Focus back button
    Hafas.Util.gui.focusFirstElement('#HFS_DocumentResultOverview');
  },

  showResultOverview: function (response) {
    var me = this;
    var controller = me.Controller.HimSearch;

    // When the result view was reached, we remove the loading screen from the history, as we do not want to go back to the loading screen
    // when we hit browser back
    Hafas.Modules.History.removeCurrentStep("loadingView");

    if(controller.currentView != 'overview'){
      // User changed to another view already, so the callback will be cancelled right here
      return;
    }

    // remove loadingImage
    if (me.trigger) {
      if (me.triggerLoadingImage) {
        try {
          me.trigger.removeChild(me.triggerLoadingImage);
          delete me.triggerLoadingImage;
        }
        catch (e) {
          // do nothing
        }
      }
      me.trigger.removeAttribute('disabled');
    }

    if (typeof Hafas.Config.showDataModel !== 'undefined' && Hafas.Config.showDataModel) {
      console.log('+++ HimSearch.showResultOverview +++ DEBUG Model +++', response)
    }

    Hafas.Modules.Render.render({
      file: 'himsearch.result.overview.html',
      target: 'HFS_HimSearch_ResultContainer',
      template: 'HimSearch_TplResults',
      model: response
    }, Hafas.bind(function () {
      if (Hafas.getWebAppContext() !== "HimSearch") {
        // When we are no longer in the HimSearch, don't render the data. Happens, if the user navigates away while
        // HimSearch takes longer to load. Otherwise the data is shown in the map and not removed again
        return;
      }

      // Announce "all content has been loaded"
      Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('common.label.t_N_LoadingEnds'));

      Hafas.ps.pub('/GUI/tabNavigationHeading/hide');

      Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);

      var searchTerm = controller.instance.getTextFilter();
      var himSearchTextfilter = Hafas('[data-additional-textfilter="HimSearch"]', false);
      var himSearchSearchMode = Hafas('#HimSearch_SortMode', false);
      if(searchTerm && searchTerm.length > 0) {
        if (himSearchTextfilter) {
          himSearchTextfilter.innerHTML = Hafas.Modules.i18n.get('HimSearch.label.t_N_SearchTerm') + ': <strong>' + controller.instance.getTextFilter() + '</strong>';
        }
        if (himSearchSearchMode) {
          himSearchSearchMode.setAttribute('data-HimSearchTextFilter',true);
        }
      }else{
        if (himSearchTextfilter) {
          himSearchTextfilter.innerHTML = '';
        }
        if (himSearchSearchMode) {
          himSearchSearchMode.removeAttribute('data-HimSearchTextFilter');
        }
      }

      var resultOverview = Hafas('#HimSearch_ResultOverview');
      if (resultOverview) {
        resultOverview.setAttribute('data-him-view', 'results');
      }

      // Add .lyr_himSearch_collapsedInput to show results in new view
      controller.mainContainer.addClassName('lyr_himSearch_collapsedInput');

      if (Hafas.Modules.History) {
        Hafas.Modules.History.addOrUpdateData("HimSearch", "results", {response: response});
      }

      // auf karte anzeigen
      if (this.Controller.Map.instance) {

        // mobil: dann meldungen noch nicht auf die karte holen
        if (this.layoutClass !== 'small') {

          // anzeige der meldungen auf der karte (wegen performance erst mit kurzem timeout)
          window.setTimeout(function () {
            Hafas.bind(controller.showDataOnMap, me)();

            // karte auf alle meldungen zentrieren/zoomen
            Hafas.bind(controller.centerDataOnMap, me)();
          }, 500);

        }
      }

      // Track
      Hafas.ps.pub('/tracking/screen/himsearch-overview', [{}]);

      Hafas.ps.pub('/app/events/resize');

    }, this));

  },

  toggleDetails: function (data) {

    if (typeof data.ev !== 'undefined') {
      data.ev.preventDefault();
      data.ev.stopPropagation();
    }

    var me = this;
    var controller = me.Controller.HimSearch;
    var results = controller.instance.data.results;

    var currMessage = null;

    // get message by id
    if (typeof data.hid !== 'undefined') {
      for (var i = 0; i < results.messages.length; i++) {
        if (results.messages[i].hid === data.hid) {
          currMessage = results.messages[i];
          break;
        }
      }
    }

    if (!currMessage) {
      return;
    }

    // schmale ansicht, dann auf karte springen
    if (this.layoutClass === 'small') {
      Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderConnection'}]);

      Hafas.bind(controller.showMsgOnMap, me)(currMessage);
      window.setTimeout(function () {
        Hafas.bind(controller.showDataOnMap, me)();
      }, 500);
    }

    // flyout auf karte anzeigen
    Hafas.bind(controller.showFlyoutOnMap, me)(currMessage);

    // highlight
    Hafas.bind(controller.highlightPolylineOnMap, me)(currMessage);

    // auf meldung zentrieren, falls moeglich
    Hafas.bind(controller.centerMessage, me)(currMessage);

    // Track
    Hafas.ps.pub('/tracking/screen/himsearch-details');
  },

  // klick auf marker in karte verarbeiten
  handleMarkerClick: function (msgObj) {
    var me = this;
    var controller = me.Controller.HimSearch;

    // flyout anzeigen
    Hafas.bind(controller.showFlyoutOnMap, me)(msgObj);

    // highlight
    Hafas.bind(controller.highlightPolylineOnMap, me)(msgObj);

    // zentrieren
    Hafas.bind(controller.centerMessage, me)(msgObj);
  },

  // klick auf polyline in karte verarbeiten
  handlePolylineClick: function (msgObj) {
    var me = this;
    var controller = me.Controller.HimSearch;

    // flyout anzeigen
    Hafas.bind(controller.showFlyoutOnMap, me)(msgObj);

    // highlight
    Hafas.bind(controller.highlightPolylineOnMap, me)(msgObj);

    // zentrieren
    Hafas.bind(controller.centerMessage, me)(msgObj);
  },

  // klick auf kreis in karte verarbeiten
  handleCircleClick: function (msgObj) {
    var me = this;
    var controller = me.Controller.HimSearch;

    // flyout anzeigen
    Hafas.bind(controller.showFlyoutOnMap, me)(msgObj);

    // highlight
    //Hafas.bind(controller.highlightPolylineOnMap, me)(msgObj);

    // zentrieren
    Hafas.bind(controller.centerMessage, me)(msgObj);
  },

  // klick auf clsuter in karte verarbeiten
  handleClusterClick: function (msgObj) {
    var me = this;
    var controller = me.Controller.HimSearch;

    // flyout ausblenden
    Hafas.bind(controller.removeFlyoutFromMap, me)();
  },

  // flyout auf karte anzeigen
  showFlyoutOnMap: function (msgObj) {
    var me = this;
    var controller = me.Controller.HimSearch;
    var map = me.Controller.Map.instance;

    controller.currMessage = msgObj;

    Hafas.Modules.Render.render({
      file: 'himsearch.result_overview.html',
      template: 'HimSearch_Map_Toolbox',
      model: msgObj
    }, function (infocontent) {
      var mobileInfoBox = document.createElement("div");
      mobileInfoBox.className = "hfs_toolboxItem";
      mobileInfoBox.innerHTML = infocontent;

      // ggf. andere toolbox schliessen
      map.removeToolboxItem('mapSelection', 'id');

      map.addToToolbox(mobileInfoBox, {
        id: 'mapSelection',
        callback: Hafas.bind(controller.unselectCurrentMessage, me)
      });
      var toolboxItem = map.getToolboxItem('mapSelection');
      map.refreshFlyoutPosition(toolboxItem);
      var toolboxHeight = mobileInfoBox.offsetHeight;

      // map offset setzen, damit die meldung nicht hinter dem flyout zentriert wird
      map.setOffset({y2: toolboxHeight});

      if (me.layoutClass === 'small') {
        map.setOffset({y: 50, x: 10, x2: 10});
      }

      Hafas.Util.gui.focusManagement.focusContainer(toolboxItem.elem, function () {
      map.removeToolboxItem('mapSelection', 'id');
        Hafas.bind(controller.unselectCurrentMessage, me);
      });


    });

  },

  // flyout ausblenden
  removeFlyoutFromMap: function () {
    var me = this;
    var map = me.Controller.Map.instance;

    map.removeToolboxItem('mapSelection', 'id');

    // map offset zuruecksetzen
    map.setOffset({y2: 0});
  },

  // anzeige der meldungen auf der karte
  showDataOnMap: function () {

    var me = this;
    var controller = me.Controller.HimSearch;
    var map = me.Controller.Map.instance;
    var results = controller.instance.getResults();

    results.messages.forEach(function (msg) {
      Hafas.bind(controller.showMsgOnMap, me)(msg);
    });

    // z-indexes der circles so setzen, dass weiterhin alles klickbar ist
    var circles = [];

    for (var msg in controller.edges) {
      if (typeof controller.edges[msg].regions !== 'undefined') {
        controller.edges[msg].regions.forEach(function (circle) {
          var mapObj = map.getContent(circle);
          if (mapObj && typeof mapObj.radius !== 'undefined') {
            circles.push({id: circle, radius: mapObj.radius});
          }
        });
      }
    }

    circles.sort(function (a, b) {
      return b - a;
    });

    circles.forEach(function (circle) {
      map.updateContent(circle.id, {bringToBack: true});
    });

  },

  // icon und polyline anzeigen
  showMsgOnMap: function (msg) {

    var me = this;
    var controller = me.Controller.HimSearch;
    var com = controller.instance.data.results.common;
    var map = me.Controller.Map.instance;

    if (typeof controller.edges[msg.hid] === 'undefined') {
      controller.edges[msg.hid] = {};

      var edgeCollection = controller.edges[msg.hid];

      // sind edges referenziert?
      if (typeof msg.edgeRefL !== 'undefined') {

        msg.edgeRefL.forEach(function (edge) {

          var edgeObj = com.himMsgEdgeL[edge];

          // polyline?
          if ((typeof edgeObj.polyG !== 'undefined') && (typeof edgeObj.polyG.polyXL !== 'undefined')) {
            if (typeof edgeCollection.polylines === 'undefined') {
              edgeCollection.polylines = [];
            }

            for (var pg = 0; pg < edgeObj.polyG.polyXL.length; pg++) {
              var extPolyIdx = edgeObj.polyG.polyXL[pg];
              var currExtPoly = com.polyL[extPolyIdx];
              var polyParams = {
                color: Hafas.Config.HimSearch.Map.defaultColor,
                width: 5,
                zIndex: 120,
                onclick: function (msg, common, that) {
                  return function (map, markerParams) {

                    Hafas.bind(controller.handlePolylineClick, me)(msg);

                  };
                }(msg, com, me),
                onmouseover: function () {
                  //Hafas.bind(controller.hoverPolylineOnMap, me)(msg.hid);
                },
                onmouseout: function () {
                  //Hafas.bind(controller.unhoverPolylineOnMap, me)(msg.hid);
                }
              };

              if (typeof msg.head !== 'undefined') {
                polyParams.text = msg.head;
              }
              if (typeof msg.title !== 'undefined') {
                polyParams.text = msg.title;
              }

              if (Hafas.Config.HimSearch.Map.highlightMethod === 'border') {
                polyParams.border = true;
                polyParams.borderColor = Hafas.Config.HimSearch.Map.highlightColor;
                polyParams.borderWidth = 4;
              }

              var polylineRef = Hafas.Util.maps.showHCIPolyline(currExtPoly, map, polyParams);

              edgeCollection.polylines.push(polylineRef);

              if (Hafas.Config.HimSearch.Map.highlightMethod === 'border') {
                map.updateContent(polylineRef, {border: false});
              }
            }
          }

          // icon? (immer nur eins verwenden)
          if ((typeof msg.icoX !== 'undefined') && (typeof edgeObj.icoCrd !== 'undefined')) {
            if (typeof edgeCollection.icons === 'undefined') {
              Hafas.bind(controller.addMsgIconToMap, me)({
                msg: msg,
                coord: Hafas.Core.newType("hafasCCoord", {
                  lon: edgeObj.icoCrd.x, lat: edgeObj.icoCrd.y
                }),
                edgeCollection: edgeCollection,
                onmouseover: function () {
                  //Hafas.bind(controller.hoverPolylineOnMap, me)(msg.hid);
                },
                onmouseout: function () {
                  //Hafas.bind(controller.unhoverPolylineOnMap, me)(msg.hid);
                }
              });
            }
          }

        });

        // Geodaten?
        if(typeof msg.geoDataXL != 'undefined'){
          for(var g=0; g < msg.geoDataXL.length;g++){
            var tmpGeoDataX = msg.geoDataXL[g];
            var geoData = com.geoDataL[tmpGeoDataX];
            if(geoData.type == 'GEOJSON'){
              var geoJsonContent = Hafas.Util.b64DecodeUnicode(geoData.data);
              var geoJsonDataParsed = JSON.parse(geoJsonContent);
              var geoJsonMapObj = this.Controller.Map.instance.createContent({
                type: 'geoJson',
                useSimpleStyle: true,
                data: geoJsonDataParsed
              });
              if (typeof edgeCollection.geoJson === 'undefined') {
                edgeCollection.geoJson = [];
              }
              edgeCollection.geoJson.push(geoJsonMapObj);
              this.Controller.Map.instance.showContent(geoJsonMapObj);
            }
          }
        }

      }

      // falls keine polyline, dann ggf. Haltestellenreferenz?
      else if (typeof msg.fLocResolved !== 'undefined') {

        // auch referenz fuer zweite haltestelle? dann luftlinien-polyline einzeichnen
        if (typeof msg.tLocResolved !== 'undefined') {

          if (typeof edgeCollection.polylines === 'undefined') {
            edgeCollection.polylines = [];
          }

          var polyParams = {
            color: Hafas.Config.HimSearch.Map.defaultColor,
            width: 5,
            zIndex: 120,
            onclick: function (msg, common, that) {
              return function (map, markerParams) {

                Hafas.bind(controller.handlePolylineClick, me)(msg);

              };
            }(msg, com, me)
          };

          if (Hafas.Config.HimSearch.Map.highlightMethod === 'border') {
            polyParams.border = true;
            polyParams.borderColor = Hafas.Config.HimSearch.Map.highlightColor;
            polyParams.borderWidth = 4;
          }

          var points = [];
          points.push(Hafas.Core.newType("hafasCCoord", {
            lon: msg.fLocResolved.crd.x,
            lat: msg.fLocResolved.crd.y
          }));
          points.push(Hafas.Core.newType("hafasCCoord", {
            lon: msg.tLocResolved.crd.x,
            lat: msg.tLocResolved.crd.y
          }));

          var addPolylineRef = Hafas.Util.maps.showHCIPolyline(points, map, polyParams);

          edgeCollection.polylines.push(addPolylineRef);

          if (Hafas.Config.HimSearch.Map.highlightMethod === 'border') {
            map.updateContent(addPolylineRef, {border: false});
          }

        }

        Hafas.bind(controller.addMsgIconToMap, me)({
          msg: msg,
          coord: Hafas.Core.newType("hafasCCoord", {
            lon: msg.fLocResolved.crd.x, lat: msg.fLocResolved.crd.y
          }),
          edgeCollection: edgeCollection
        });

      }

      // falls keine polyline, dann ggf. Haltestellenreferenz?
      else if (typeof msg.tLocResolved !== 'undefined') {

        Hafas.bind(controller.addMsgIconToMap, me)({
          msg: msg,
          coord: Hafas.Core.newType("hafasCCoord", {
            lon: msg.tLocResolved.crd.x, lat: msg.tLocResolved.crd.y
          }),
          edgeCollection: edgeCollection
        });

      }

      // Geodaten
      if(typeof msg.matchGeoDataX != 'undefined'){
        var tmpGeoDataX = msg.matchGeoDataX;
        var geoData = com.geoDataL[tmpGeoDataX];
        if(geoData.type == 'GeoJSON'){
          var geoJsonContent = Hafas.Util.b64DecodeUnicode(geoData.data);
          var geoJsonDataParsed = JSON.parse(geoJsonContent);
          var geoJsonMapObj = this.Controller.Map.instance.createContent({
            type: 'geoJson',
            useSimpleStyle: true,
            data: geoJsonDataParsed
          });
          if (typeof edgeCollection.geoJson === 'undefined') {
            edgeCollection.geoJson = [];
          }
          edgeCollection.geoJson.push(geoJsonMapObj);
          this.Controller.Map.instance.showContent(geoJsonMapObj);
        }
      }

      // region?
      if (typeof msg.regionL !== 'undefined') {

        if (typeof edgeCollection.regions === 'undefined') {
          edgeCollection.regions = [];
        }

        for (var pg = 0; pg < msg.regionL.length; pg++) {
          var poly = msg.regionL[pg];

          // umkreis?
          if (typeof poly.ring !== 'undefined') {
            var polylineRef = map.createContent({
              type: "circle",
              coord: Hafas.Core.newType("hafasCCoord", {lon: poly.ring.cCrd.x, lat: poly.ring.cCrd.y}),
              radius: poly.ring.maxDist,
              color: Hafas.Config.HimSearch.Map.defaultColor,
              fillColor: Hafas.Config.HimSearch.Map.defaultColor,
              fillOpacity: 0.2,
              onclick: function (msg, common, that) {
                return function (map, markerParams) {
                  Hafas.bind(controller.handleCircleClick, me)(msg);
                };
              }(msg, com, me),
              onmouseover: function () {
                //Hafas.bind(controller.hoverCircleOnMap, me)(msg.hid);
              },
              onmouseout: function () {
                //Hafas.bind(controller.unhoverCircleOnMap, me)(msg.hid);
              }
            });

            edgeCollection.regions.push(polylineRef);
            map.showContent(polylineRef);

          }

        }

      }

    }

  },

  unselectCurrentMessage: function (obj) {
    var me = this;
    var controller = me.Controller.HimSearch;

    for (var msg in controller.edges) {
      Hafas.bind(controller.unhoverPolylineOnMap, me)(msg);
    }
  },

  // icon zu einer meldung auf karte hinzufuegen
  addMsgIconToMap: function (obj) {
    var me = this;
    var controller = me.Controller.HimSearch;
    var com = controller.instance.data.results.common;
    var map = me.Controller.Map.instance;

    var msg = obj.msg;
    var edgeCollection = obj.edgeCollection;

    var imageheight = 30;
    var imagewidth = 30;
    var hotspot = {x: 15, y: 15};
    var bgCss = Hafas.Config.HimSearch.Map.defaultColor;

    var image = Hafas.Util.getImage(com.icoL[msg.icoX].res + '_map');

    var params = {
      type: "location",
      cluster: "himSearch",
      clusterText: function (cluster) {

        return cluster.getChildCount() + ' ' + Hafas.Modules.i18n.get('HimSearch.mouseover.t_N_ClusterPopup');
      },
      clusterOnclick: function (cluster) {
        Hafas.ps.pub('/HimSearch/clickOnCluster');
      },
      coord: obj.coord,
      fillcolor: bgCss,
      imageurl: image,
      imageheight: imageheight,
      imagewidth: imagewidth,
      text: msg.head,
      hotspot: hotspot,
      hotspotType: "fraction",
      imagescale: 0.5,
      priority: 1000,
      //selectable: true,
      onclick: function (msg, common, that) {
        return function (map, markerParams) {

          Hafas.bind(controller.handleMarkerClick, me)(msg);

        };
      }(msg, com, me)
    };

    if (typeof obj.onmouseover !== 'undefined') {
      params.onmouseover = obj.onmouseover;
    }
    if (typeof obj.onmouseout !== 'undefined') {
      params.onmouseout = obj.onmouseout;
    }

    var tmpIcon = map.createContent(params);
    if (typeof edgeCollection.icons === 'undefined') {
      edgeCollection.icons = [];
    }
    edgeCollection.icons.push(tmpIcon);
    map.showContent(tmpIcon);

  },

  // polyline highlighten
  highlightPolylineOnMap: function (msgObj) {
    var me = this;
    var controller = me.Controller.HimSearch;
    var map = me.Controller.Map.instance;

    // bisherige gehighlightete polyline nicht mehr highlighten
    for (var msg in controller.edges) {
      Hafas.bind(controller.unhoverPolylineOnMap, me)(msg);
    }

    if (typeof controller.edges[msgObj.hid] !== 'undefined') {

      var edgeCollection = controller.edges[msgObj.hid];

      if (typeof edgeCollection.polylines !== 'undefined') {
        edgeCollection.polylines.forEach(function (currPoly) {
          // wie wird hervorgehoben?
          // farbe?
          if (Hafas.Config.HimSearch.Map.highlightMethod === 'color') {
            map.updateContent(currPoly, {color: Hafas.Config.HimSearch.Map.highlightColor, bringToFront: true});
          }
          // border?
          else if (Hafas.Config.HimSearch.Map.highlightMethod === 'border') {
            map.updateContent(currPoly, {border: true, bringToFront: true});
          }
        });
      }

      // icon ggf. aus cluster herausloesen
      if (typeof edgeCollection.icons !== 'undefined') {
        edgeCollection.icons.forEach(function (currIcon) {
          map.updateContent(currIcon, {cluster: false});
        });
      }

    }

  },

  // polyline nicht mehr highlighten
  unhoverPolylineOnMap: function (himId) {
    var me = this;
    var controller = me.Controller.HimSearch;
    var map = me.Controller.Map.instance;

    if (typeof controller.edges[himId] !== 'undefined') {

      var edgeCollection = controller.edges[himId];

      if (typeof edgeCollection.polylines !== 'undefined') {
        edgeCollection.polylines.forEach(function (currPoly) {
          // wie wird hervorgehoben?
          // farbe?
          if (Hafas.Config.HimSearch.Map.highlightMethod === 'color') {
            map.updateContent(currPoly, {color: Hafas.Config.HimSearch.Map.defaultColor});
          }
          // border?
          else if (Hafas.Config.HimSearch.Map.highlightMethod === 'border') {
            map.updateContent(currPoly, {border: false});
          }
        });
      }

      // icon ggf. wieder ins cluster einfuegen
      if (typeof edgeCollection.icons !== 'undefined') {
        edgeCollection.icons.forEach(function (currIcon) {
          map.updateContent(currIcon, {cluster: true, clusterName: 'himSearch'});
        });
      }

    }
  },

  // icon und polyline von karte entfernen
  removeMsgFromMap: function (msg) {

    var me = this;
    var controller = me.Controller.HimSearch;
    var map = me.Controller.Map.instance;

    if (typeof controller.edges[msg] !== 'undefined') {

      var edgeCollection = controller.edges[msg];

      // polyline?
      if (typeof edgeCollection.polylines !== 'undefined') {
        edgeCollection.polylines.forEach(function (removeEdge) {
          map.hideContent(removeEdge);
          map.removeContent(removeEdge);
        });
      }

      // icon?
      if (typeof edgeCollection.icons !== 'undefined') {
        edgeCollection.icons.forEach(function (removeIcon) {
          map.hideContent(removeIcon);
          map.removeContent(removeIcon);
        });
      }

      // region?
      if (typeof edgeCollection.regions !== 'undefined') {
        edgeCollection.regions.forEach(function (removeIcon) {
          map.hideContent(removeIcon);
          map.removeContent(removeIcon);
        });
      }

      delete controller.edges[msg];
    }
  },

  clearMapContent: function () {
    var me = this;
    var controller = me.Controller.HimSearch;

    for (var msg in controller.edges) {
      Hafas.bind(controller.removeMsgFromMap, me)(msg);
    }
  },

  // If the user navigations back, this function needs to be used in order to remove the "disabled" state from the search button
  reactivateSeachButton: function(){
    var himSearchSubmitButton = Hafas('#HFS_FormHimSearch [name="submitHimSearchForm"]',false);
    himSearchSubmitButton.disabled = false;
  },

  // boundingbox einer meldung ermitteln (d.h. es werden alle koordinaten von polylines und icon ermittelt)
  getMsgBoundingBox: function (msg) {
    var me = this;
    var controller = me.Controller.HimSearch;
    var map = me.Controller.Map.instance;
    var com = controller.instance.data.results.common;

    var allCoords = [];

    // sind edges referenziert?
    if (typeof msg.edgeRefL !== 'undefined') {
      msg.edgeRefL.forEach(function (edge) {

        var edgeObj = com.himMsgEdgeL[edge];

        // polyline?
        if ((typeof edgeObj.polyG !== 'undefined') && (typeof edgeObj.polyG.polyXL !== 'undefined')) {
          for (var pg = 0; pg < edgeObj.polyG.polyXL.length; pg++) {
            var extPolyIdx = edgeObj.polyG.polyXL[pg];
            var currExtPoly = com.polyL[extPolyIdx];

            allCoords = allCoords.concat(Hafas.Util.decodeGooglePolyline(currExtPoly.crdEncYX));
          }
        }

        // icon?
        if (typeof edgeObj.icoCrd !== 'undefined') {
          var coord = Hafas.Core.newType("hafasCCoord", {
            lon: edgeObj.icoCrd.x, lat: edgeObj.icoCrd.y
          });
          allCoords.push(coord);
        }

      });
    }

    // falls kein icon, dann ggf. Haltestellenreferenz?
    else if ((typeof msg.fLocResolved !== 'undefined') || (typeof msg.tLocResolved !== 'undefined')) {
      if (typeof msg.fLocResolved !== 'undefined') {
        var coord = Hafas.Core.newType("hafasCCoord", {
          lon: msg.fLocResolved.crd.x, lat: msg.fLocResolved.crd.y
        });
        allCoords.push(coord);
      }
      if (typeof msg.tLocResolved !== 'undefined') {
        var coordT = Hafas.Core.newType("hafasCCoord", {
          lon: msg.tLocResolved.crd.x, lat: msg.tLocResolved.crd.y
        });
        allCoords.push(coordT);
      }
    }

    // circle?
    if (typeof msg.regionRefL !== 'undefined') {

      function _toRadians(angleInDegrees) {
        return angleInDegrees * Math.PI / 180;
      }

      function _toDegrees(angleInRadians) {
        return angleInRadians * 180 / Math.PI;
      }

      function _offset(c1, distance, bearing) {
        var lat1 = _toRadians(c1[1]);
        var lon1 = _toRadians(c1[0]);
        var dByR = distance / 6378137; // distance divided by 6378137 (radius of the earth) wgs84
        var lat = Math.asin(
          Math.sin(lat1) * Math.cos(dByR) +
          Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
        var lon = lon1 + Math.atan2(
          Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1),
          Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
        return [_toDegrees(lon), _toDegrees(lat)];
      }

      msg.regionRefL.forEach(function (reg) {
        var poly = com.himMsgRegionL[reg];

        // umkreis?
        if (typeof poly.ring !== 'undefined') {
          var n = 4;
          for (var i = 0; i < n; ++i) {
            var offsetCoord = _offset([poly.ring.cCrd.x / 1000000, poly.ring.cCrd.y / 1000000], poly.ring.maxDist, 2 * Math.PI * i / n);

            var coord = Hafas.Core.newType("hafasCCoord", {
              lon: offsetCoord[0] * 1000000, lat: offsetCoord[1] * 1000000
            });
            allCoords.push(coord);
          }

        }
      });
    }

    return allCoords;
  },

  // karte auf eine edge zentrieren
  centerMessage: function (msg) {

    var me = this;
    var controller = me.Controller.HimSearch;
    var map = me.Controller.Map.instance;

    var allCoords = Hafas.bind(controller.getMsgBoundingBox, me)(msg);

    if (allCoords.length > 0) {
      Hafas.Util.maps.centerToCoords(allCoords, map);
    }

  },

  // karte auf alle meldungen zentrieren/zoomen
  centerDataOnMap: function () {

    var me = this;
    var controller = me.Controller.HimSearch;
    var results = controller.instance.getResults();
    var map = me.Controller.Map.instance;
    var allCoords = [];

    results.messages.forEach(function (msg) {
      allCoords = allCoords.concat(Hafas.bind(controller.getMsgBoundingBox, me)(msg));
    });

    if (allCoords.length > 0) {
      Hafas.Util.maps.centerToCoords(allCoords, map);
    }

  },

  resize: function () {
    // ueberhaupt im richtigen kontext?
    // if(this.appContext === 'HimSearch'){
    //   var me = this;
    //   var controller = me.Controller.HimSearch;

    //   // jleo: Um .lyr_himSearch_collapsedInput zu togglen, wird dieser Abschnitt weiterhin benötigt
    //   var resOverview = Hafas('#HimSearch_ResultOverview',false);
    //   if(resOverview){
    //     resOverview.removeClassName('lyr_himSearch_collapsedInput');

    //     if(window.innerHeight < 800){

    //       if(resOverview.getAttribute('data-him-view') === 'results'){
    //         resOverview.addClassName('lyr_himSearch_collapsedInput');
    //       }

    //     }

    //     // muss das eingabeformular scrollen?
    //     /* jleo: Im Rahmen des Flexbox-Umbaus wird das letzte if-Statement vermutlich niemals true

    //     var formDiv = Hafas('[data-render-element="result_header"]',false,resOverview);
    //     if(formDiv){
    //       formDiv.style.maxHeight = '';
    //       formDiv.style.height = '';
    //       formDiv.style.overflow = '';
    //       if((resOverview.getAttribute('data-him-view') === 'index') || (resOverview.getAttribute('data-him-view') === 'results')) {
    //         var tabNavHeight = 0;
    //         var tabNav = Hafas('#HFS_TabNavigation',false);
    //         if(tabNav){
    //           tabNavHeight = tabNav.offsetHeight;
    //         }
    //         var filterHeight = 0;
    //         var filter = Hafas('#HimSearch_SortMode',false);
    //         if(filter){
    //           filterHeight = filter.offsetHeight;
    //         }

    //         if((formDiv.offsetHeight+filterHeight+tabNavHeight) > window.innerHeight){
    //           formDiv.style.height = (formDiv.offsetHeight+filterHeight)+'px';
    //           formDiv.style.maxHeight = (window.innerHeight-tabNavHeight)+'px';
    //           formDiv.style.overflow = 'auto';
    //         }

    //       }
    //     } */
    //   }
    // }
  },

  resizeForm: function () {
    // ueberhaupt im richtigen kontext?
    if (this.appContext === 'HimSearch') {
      window.setTimeout(function () {
        Hafas.ps.pub('/app/events/resize');
      }, 0)
    }
  },

  cleanup: function () {
    var me = this;
    var controller = me.Controller.HimSearch;

    // inhalte entfernen
    Hafas('#' + me.formContainer, false).innerHTML = '';
    controller.mainContainer.innerHTML = '';

    // karte leeren
    Hafas.bind(controller.clearMapContent, me)();

    // ggf toolbox schliessen
    Hafas.bind(controller.removeFlyoutFromMap, me)();
  },

  leaveContext: function () {
    var me = this;
    var controller = me.Controller.HimSearch;

    Hafas.bind(controller.cleanup, me)();
  },

  closeView: function (histData) {
    var me = this;
    var controller = me.Controller.HimSearch;

    controller.lastView = histData.view;
  },

  restoreView: function (histData) {
    var me = this;
    var controller = me.Controller.HimSearch;
    var lastView = controller.lastView;
    var newView = histData.view;

    // map -> results
    if ((lastView === 'map') && (newView === 'results') || ((lastView == 'map') && (newView == 'index'))) {
      Hafas.ps.pub('/GUI/map/hide', []);
    }
    // results -> index
    else if ((lastView === 'results') && (newView === 'index')) {
      Hafas.ps.pub('/GUI/tabNavigationHeading/show');
      var resultOverviewContainer = Hafas('#HimSearch_ResultOverview');
      resultOverviewContainer.setAttribute('data-him-view', 'index');
      Hafas.Util.gui.focusFirstElement('#HFS_PageContent');
      resultOverviewContainer.removeClassName('lyr_himSearch_collapsedInput');
      var himSearchResultContainer = Hafas('#HFS_HimSearch_ResultContainer');
      if (himSearchResultContainer !== null) {
        himSearchResultContainer.innerHTML = '';
      }
      Hafas.bind(me.Controller.HimSearch.clearMapContent, me)();
      Hafas.bind(me.Controller.HimSearch.removeFlyoutFromMap, me)();
      me.Controller.HimSearch.currentView = 'index';
      Hafas.ps.pub('/app/events/resize');
    }
    // results -> index
    else if (((lastView === null) || (lastView === 'index')) && (newView === 'index')) {
      Hafas.ps.pub('/GUI/tabNavigationHeading/show');
      Hafas.bind(me.Controller.HimSearch.index, me)();
    }
    // index -> results
    else if ((lastView === 'index') && (newView === 'results')) {
      me.Controller.HimSearch.currentView = 'overview';
      Hafas.bind(me.Controller.HimSearch.showResultOverview, me)(histData.data.response);
    }
    // results -> map
    else if ((lastView === 'results') && (newView === 'map')) {
      Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderConnection'}]);

      Hafas.bind(controller.showMsgOnMap, me)(controller.currMessage);
      window.setTimeout(function () {
        Hafas.bind(controller.showDataOnMap, me)();
      }, 500);

      // flyout auf karte anzeigen
      Hafas.bind(controller.showFlyoutOnMap, me)(controller.currMessage);

      // highlight
      Hafas.bind(controller.highlightPolylineOnMap, me)(controller.currMessage);

      // auf meldung zentrieren, falls moeglich
      Hafas.bind(controller.centerMessage, me)(controller.currMessage);
    }
    else if ((lastView === null) && (newView === 'results')) {
      Hafas.bind(me.Controller.HimSearch.renderIndex, me)(histData.data);

      me.Controller.HimSearch.currentView = 'overview';
      Hafas.bind(me.Controller.HimSearch.showResultOverview, me)(histData.data.response);
    }

  },

  /**
   * clears all input data (including options)
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt
    Hafas.Modules.History.removeCurrentStep("index", () => {
      Hafas.ps.pub('/app/switchContext', [{context: 'HimSearch', method: 'index'}]);

    });
    Hafas.ps.pub('/options/reset');
    var me = this;
    me.Controller.HimSearch.sDateDTP.setTimeNowOn(); // Default Date aus dem HimSearch-Modul
    Hafas.bind(me.Controller.HimSearch.setEndDate, me)(Hafas.Util.date.jsDate2hciDate(Hafas.Config.periodEnd).hciDate, Hafas.Util.date.jsDate2hciDate(Hafas.Config.periodEnd).hciTime); // Default Date aus dem HimSearch-Modul
    me.Controller.HimSearch.instance.setTextFilter(""); // Reset textfilter

    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  },

  /**
   * Decides whether the options should be stored locally or not (temporarily [de]activating)
   * @param {Boolean} boolval Sets the value of localOptionsActive
   */
  setOptionStorageActive: function (boolval) {
    if (Hafas.Config.Options && Hafas.Config.Options.storeOptions === true) {
      this.Controller.HimSearch.localOptionsActive = boolval;
    }
  },

};
